const initialize = () => {
    
}

window.addEventListener('DOMContentLoaded', () => initialize())